import React from "react";
import styled from "@emotion/styled";
import {
  ProductInformation as ProductInformationValues,
  productInformationDisplayValue,
  productInformationTextFields,
} from "@utils/productInformation";

export default function ProductInformation({ productInfo }: { productInfo?: ProductInformationValues }) {
  return (
    <Section>
      <h2>Product Information</h2>
      <dl>
        <Row><dt>상품 MOQ</dt><dd>{productInformationDisplayValue(productInfo?.product_moq)}</dd></Row>
        {productInformationTextFields.map(([field, label]) => (
          <Row key={field}><dt>{label}</dt><dd>{productInformationDisplayValue(productInfo?.[field])}</dd></Row>
        ))}
      </dl>
    </Section>
  );
}

const Section = styled.section(({ theme }) => ({
  padding: "2rem", lineHeight: "2rem",
  h2: { fontSize: "1.6rem", fontWeight: theme.fontWeight.semiBold, marginBottom: "2rem" },
}));
const Row = styled.div(({ theme }) => ({
  display: "grid", gridTemplateColumns: "minmax(0, 1fr) minmax(0, 1fr)", gap: "1rem",
  padding: "1rem 0", borderBottom: `1px solid ${theme.color.border_gray}`,
  dt: { color: theme.color.gray }, dd: { margin: 0, whiteSpace: "pre-wrap", overflowWrap: "anywhere" },
}));
